import { h } from 'preact';
import React, { Component } from 'react';

import Switch from './Components/Switch';

import { CategoriesSettings } from './CategoriesSettings';
import { Sanitize } from '../Sanitize/Sanitize';
import { makeText, isActionAllowed } from '../../util';

import './Categories.css';


export class Categories extends Component {
  state = {
    page: 'consent',
    loading: true
  }
  componentDidMount = () => {
    this.loadStacks();
  }
  componentDidUpdate = (prevProps) => {
    const { language } = this.props;
    if (language !== prevProps.language) this.loadStacks();
  }
  loadStacks = () => {
    const { siteId, cmpv2Origin, preloadMsg, language } = this.props;
    const origin = cmpv2Origin || 'https://sourcepoint.mgr.consensu.org/tcfv2';
    if (siteId && !preloadMsg) {
      fetch(`${origin}/vendor-list/categories?siteId=${siteId}${language ? `&consentLanguage=${language.toLowerCase()}` : ''}`, {
        insecure: true
      }).then(r => r.json()).then(data => {
          try {
            this.props.updateStacks(data.categories);
            this.setState({ loading: false }, this.getConsent);
          } catch (e) {
            this.defaultStacks();
          }
        });
    } else {
      this.defaultStacks();
    }
  }
  getConsent = () => {
    const { siteId, cmpv2Origin, language, consentUUID } = this.props;
    const origin = cmpv2Origin || 'https://sourcepoint.mgr.consensu.org/tcfv2';
    fetch(
      `${origin}/consent/v3/${siteId}?consentUUID=${consentUUID}&consentLanguage=${language}&separateLegIntVendors=true`, 
      { insecure: true }
    ).then(r => (r ? r.json() : null)).then(cData => {
      let stackData = [...this.props.stacksData];
      const legIntConsent = cData ? cData.legIntCategories || [] : [];
      const categoriesConsent = cData ? cData.categories || [] : [];
      stackData = stackData.map(s => {
        s.legInt = legIntConsent.indexOf(s._id) > -1 || s.hasLegInt ? true : false;
        s.consent = categoriesConsent.indexOf(s._id) > -1 || s.hasConsent ? true : false;
        return s;
      })
      this.props.updateStacks(stackData);
    }).catch((err) => console.log('Error returning consent'));
  }
  defaultStacks = () => {
    this.setState({ loading: false }, this.getConsent);
  }
  linkHover = (e, which) => {
    e.target.style.color = which.color;
    e.target.style.textDecoration = which.textDecoration;
    e.target.style.fontWeight = which.fontWeight;
  }
  togglePage = () => this.setState({ page: this.state.page === 'consent' ? 'legInt' : 'consent' })
  toggleCategory = (catId, value, page) => {
    const categories = [...this.props.stacksData];
    categories.map(c => {
      if (catId === c._id) c[page] = value;
      return c;
    })
    this.props.updateStacks(categories);
  }
  render() {
    const Settings = new CategoriesSettings(this.props.component.settings);
    const { language, stacksData } = this.props;

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const thFont = { ...Settings.tableHeaderFont, ...Settings.tableCellSpacing  };
    const tdFont = { ...Settings.tableBodyFont, ...Settings.tableCellSpacing  };
    const useTitleFont = { ...Settings.useTitleFont  };
    const useFont = { ...Settings.useFont  };
    const titleFont = { ...Settings.titleFont };

    const linkAttributes = {
      style: Settings.link,
      onMouseOver: (e) => this.linkHover(e, Settings.hover),
      onMouseOut: (e) => this.linkHover(e, Settings.link)
    };

    const linkConsentText = makeText(Boolean(this.props.dev), Settings, 'linkConsentText', language);
    const linkLIText = makeText(Boolean(this.props.dev), Settings, 'linkLIText', language);

    const categoriesText = makeText(Boolean(this.props.dev), Settings, 'categoriesText', language);
    const descriptionText = makeText(Boolean(this.props.dev), Settings, 'descriptionText', language);
    const consentText = makeText(Boolean(this.props.dev), Settings, 'consentText', language);
    const liText = makeText(Boolean(this.props.dev), Settings, 'liText', language);
    const categoriesUseText = makeText(Boolean(this.props.dev), Settings, 'categoriesUseText', language);

    const consentCategories = (stacksData || []).filter(s => s.type === 'CUSTOM' && s.hasConsent);
    const liCategories = (stacksData || []).filter(s => s.type === 'CUSTOM' && s.hasLegInt);
    const iabCategories = (stacksData || []).filter(s => s.type === 'IAB_PURPOSE' || s.type === 'IAB_STACK');

    let page = this.state.page;
    if (this.state.page === 'consent' && consentCategories.length <= 0 && liCategories.length > 0) page = 'legInt';

    const className = 'message-component message-stacks no-children' + this.props.className;
    return (
      <div className={selected ? className + ' on-active' : className} path={this.props.dev ? path : null} {...devActions}>
        { (consentCategories && consentCategories.length > 0) || (liCategories && liCategories.length > 0) || (iabCategories && iabCategories.length > 0)  ? (
          <div className="categories-container">
            { iabCategories && iabCategories.length > 0 ? (
              <div>
                <div className="page-use-title" style={useTitleFont}>{categoriesUseText}</div>
                <div className="page-use" style={useFont}>
                  { iabCategories.map(c => <div><span><b>{c.name}: </b></span><span>{c.description}</span></div>) }
                </div>
              </div>
            ) : null }
            { (consentCategories && consentCategories.length > 0) || (liCategories && liCategories.length > 0) ? (
            <div>
              <div className="page-title" style={titleFont}>{ page === 'consent' ? consentText : liText}</div>
              <table className="cat-tbl">
                <thead>
                  <tr>
                    <th style={thFont}>{categoriesText}</th>
                    <th style={thFont}>{descriptionText}</th>
                    <th style={thFont}>{ page === 'consent' ? consentText : liText}</th>
                  </tr>
                </thead>
                <tbody>
                  { (page === 'consent' ? consentCategories : liCategories).map(c => (
                    <tr key={`cat-${c._id}`}>
                      <td style={tdFont}>{c.name}</td>
                      <td style={tdFont} dangerouslySetInnerHTML={{ __html: Sanitize({ html: c.description }) }} />
                      <td style={tdFont}>
                        <Switch
                          value={c}
                          checked={c[page]}
                          toggle={this.toggleCategory}
                          page={page}
                          dev={this.props.dev}
                          settings={Settings}
                          language={language}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            ) : null }
            { (page === 'consent' && liCategories.length > 0) || (page === 'legInt' && consentCategories.length > 0) ? (
              <div className="bottom-link">
                <div tabIndex="0" {...linkAttributes} onClick={this.togglePage} onKeyDown={(e) => isActionAllowed(e.key) && this.togglePage}>
                  { page === 'consent' ? linkLIText : linkConsentText }
                </div>
              </div>
            ) : null }
          </div>
        ) : (
          <div className="no-categories">
            This vendor list does not have any categories/purposes yet
          </div>
        )}
      </div>
    );
  }
}
